import { Divider } from '@chakra-ui/react';

export const SidebarDivider = () => <Divider pt='1' borderColor='border' />;
